import type { SVGProps } from 'react';
const SvgBus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <path
      d="M3.514 13.215v.892c0 .237.105.464.292.632s.44.261.705.261.518-.094.705-.261a.85.85 0 0 0 .292-.632v-.892m6.978 0v.892a.85.85 0 0 1-.292.632 1.06 1.06 0 0 1-.705.261c-.264 0-.518-.094-.705-.261a.85.85 0 0 1-.292-.632v-.892m-5.77-2.217h1.43m3.696 0h1.43m2.222 1.277c0 .25-.105.488-.293.664a1.03 1.03 0 0 1-.707.276h-9c-.265 0-.52-.1-.707-.276a.91.91 0 0 1-.293-.664V3.819c0-.748.316-1.465.879-1.993A3.1 3.1 0 0 1 5.5 1h5a3.1 3.1 0 0 1 2.121.826c.563.528.879 1.245.879 1.993zM2.517 4.749h10.966v4.463H2.517z"
      strokeLinejoin="round"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
    />
  </svg>
);
export default SvgBus;
